export const getAgentConfig = (state, configKey) => {
  const data = state.api.configurations.agentConfigurations.data;

  if (data) {
    return data[configKey];
  }
};
